import { SNAPSHOT_EVENT_NAME } from './constants';
export function closeGlobalSnapshot() {
	const event = new CustomEvent(SNAPSHOT_EVENT_NAME, {
		detail: { open: false, employeeId: '' },
	});
	window.dispatchEvent(event);
}
